/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { WarrantExerciseService } from '@wealthlane/api-services/wealthlane-captable-service';

const usePostCancelWarrantExercise = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void
): UseMutationResult<undefined, unknown, any, unknown> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (warrantExerciseId: string) => {
      return await handleRequest(
        WarrantExerciseService.postApiCapTableApiAppWarrantExerciseCancelWarrantExercise(warrantExerciseId)
      );
    },
    {
      onSuccess: (response: any) => {
        void queryClient.invalidateQueries('getWarrantExerciseList');
        closeModal();
        toast.success(<ToastComponent label='Success' message='Warrant exercise cancelled.' />);
      },
      onError: (err) => {
        console.log('error', err);
        closeModal();
      },
    }
  );
};

export default usePostCancelWarrantExercise;
